import { createIcon } from '~/utils';

export const AppleIcon = createIcon({
  viewBox: '0 0 14 16',
  path: (
    <path
      fill='white'
      d='M11.5189 8.45515C11.5118 7.14415 12.1047 6.15464 13.305 5.42591C12.6334 4.46498 11.6189 3.93629 10.2793 3.83269C9.01119 3.73267 7.62517 4.57214 7.11791 4.57214C6.58208 4.57214 5.35323 3.86842 4.38873 3.86842C2.39543 3.90057 0.2771 5.45806 0.2771 8.62662C0.2771 9.56254 0.448566 10.5306 0.7915 11.5273C1.24875 12.8383 2.89911 16.0533 4.62093 15.9997C5.52113 15.9783 6.15698 15.3603 7.32867 15.3603C8.46464 15.3603 9.05406 15.9997 10.0579 15.9997C11.794 15.9747 13.2871 13.0526 13.723 11.738C11.3939 10.6414 11.5189 8.52303 11.5189 8.45515ZM9.49701 2.58956C10.4722 1.43216 10.3829 0.378351 10.3543 -0.000305176C9.49344 0.049706 8.49679 0.58554 7.92881 1.2464C7.30367 1.9537 6.93573 2.8289 7.01432 3.81483C7.94667 3.88628 8.79686 3.4076 9.49701 2.58956Z'
    />
  ),
});
